"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utilities = require("../Header/HeaderSkeleton/utilities");

function getCookie(name) {
  if (_utilities.IsServerSideRendering) return {};
  var regexp = new RegExp("(?:^".concat(name, "|; *").concat(name, ")=(.*?)(?:;|$)"), 'g');
  var result = regexp.exec(document.cookie);
  return result === null ? null : result[1];
}

function setCookie(name, value, expireDate) {
  if (_utilities.IsServerSideRendering) return;
  var expires = expireDate ? "; expires=".concat(expireDate) : '';
  document.cookie = "".concat(name, "=").concat(value).concat(expires, "; path=/");
}

function deleteCookie(name) {
  this.setCookie(name, '', -1);
}

var _default = {
  getCookie: getCookie,
  setCookie: setCookie,
  deleteCookie: deleteCookie
};
exports.default = _default;
module.exports = exports.default;